import {panelIsActive} from '../../../util/panelbank';
import {PANEL_BANK_HIDDEN_SECTION_NAME} from '../../../util/panelbankTypes';
import {keyExistsInQueryString} from '../../../util/query-string';
import {useKeyTypes} from '../../../util/runhelpers';
import {useKeyInfoQueryContext} from '../../MultiRunWorkspace/KeyInfoQueryContext';
import {useSingleRunModeContext} from '../../MultiRunWorkspace/SingleRunMode';
import {usePanelBankConfigWithRefs} from '../hooks/usePanelBankConfigWithRefs';
import {PanelBankConfigState} from '../types';

export const useIsWorkspaceEmpty = (): boolean => {
  const {isSingleRun} = useSingleRunModeContext();
  const {
    keyInfoQuery: {historyKeyInfo},
  } = useKeyInfoQueryContext();
  const keyTypes = useKeyTypes(historyKeyInfo.keys);

  const {state: panelBankConfigState, sections: panelBankSections} =
    usePanelBankConfigWithRefs();

  if (
    panelBankConfigState === PanelBankConfigState.Ready ||
    historyKeyInfo.lastStep == null ||
    historyKeyInfo.lastStep >= 0
  ) {
    return false;
  }

  for (const [idx, section] of panelBankSections.entries()) {
    // always skip last section "Hidden Panels" unless query string is set
    if (
      section.name === PANEL_BANK_HIDDEN_SECTION_NAME &&
      idx === panelBankSections.length - 1 &&
      !keyExistsInQueryString('SHOW_HIDDEN_SECTION') // for dev debugging purposes
    ) {
      continue;
    }

    const hasAnyActivePanel = section.panels.some(panel =>
      panelIsActive({
        section,
        panel,
        isSingleRun,
        historyKeyInfo,
        keyTypes,
      })
    );

    if (hasAnyActivePanel) {
      return false;
    }
  }

  return true;
};
